import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import type DocumentFolder from 'stores/DocumentFolder';
import store from 'stores/RootStore';
import { DocumentType } from 'types/DocumentType';

import StarredTable from '../../UI/StarredTable/StarredTable';
import ViewsLayout from '../../UI/ViewsLayout/ViewsLayout';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

function groupDocumentsByType(documents: ReadonlyArray<DocumentFolder>) {
  const byType = new Map<DocumentType, DocumentFolder[]>();
  for (const document of documents) {
    const group = byType.get(document.type);
    if (group) {
      group.push(document);
    } else {
      byType.set(document.type, [document]);
    }
  }

  return {
    clientDocuments: byType.get(DocumentType.CLIENT) || [],
    projectDocuments: byType.get(DocumentType.PROJECT) || [],
    creativeDocuments: byType.get(DocumentType.CREATIVE) || [],
  };
}

function Dashboard() {
  const store_user_starred = store.user.starred;

  const isLoading = store_user_starred.loading;
  const hasBeenLoaded = store_user_starred.firstLoadComplete;

  useEffect(() => {
    document.title = 'Dashboard';
  }, []);

  const { clientDocuments, projectDocuments, creativeDocuments } =
    groupDocumentsByType(store_user_starred.documents);

  const groups: Array<[string, DocumentFolder[]]> = [
    ['Starred Clients', clientDocuments],
    ['Starred Projects', projectDocuments],
    ['Starred Creatives', creativeDocuments],
  ];

  return (
    <ViewsLayout isLoading={isLoading && !hasBeenLoaded}>
      <Container>
        {groups.map(([title, items]) => (
          <StarredTable
            key={title}
            title={title}
            items={items}
            onItemClick={(record) => {
              record.navigateTo();
            }}
          />
        ))}
      </Container>
    </ViewsLayout>
  );
}

export default observer(Dashboard);
